module.exports = __webpack_public_path__ + "static/media/team3.030457a4.jpg";